import React from 'react';

import { ToggleField } from '@dndbeyond/character-common-components/es';

import { ToggleInfo } from './typings';

interface Props {
    toggles: Array<ToggleInfo>;
    heading: React.ReactNode;
    description: React.ReactNode;
}
export default class FormTogglesField extends React.PureComponent<Props, {}> {
    static defaultProps = {
        initiallyEnabled: false,
    };

    render() {
        const { heading, description, toggles } = this.props;
        if (!toggles.length) {
            return null;
        }

        return (
            <div className="builder-field builder-field-toggles">
                <div className="builder-field-toggles-summary">
                    <div className="builder-field-toggles-heading">{heading}</div>
                    {description && <div className="builder-field-toggle-description">{description}</div>}
                </div>
                <div className="builder-field-toggles-fields">
                    {toggles.map((toggle, idx) => (
                        <div className="builder-field-toggles-field" key={idx}>
                            <div className="builder-field-toggles-field-input">
                                <ToggleField
                                    label={toggle.label}
                                    initiallyEnabled={toggle.initiallyEnabled}
                                    onChange={toggle.onChange}
                                    onChangePromise={toggle.onChangePromise}
                                />
                            </div>
                            <div className="builder-field-toggles-field-label">{toggle.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
